import { gql } from '@apollo/client';

export const CREATE_JOB = gql`
  mutation CreateJob($input: CreateJobInput!) {
    createJob(input: $input) {
      idempotencyKey
      jobId
      revisionId
    }
  }
`;

export const REFRESH_JOB = gql`
  mutation RefreshJob($input: RefreshJobInput!) {
    refreshJob(input: $input) {
      idempotencyKey
      jobId
      revisionId
    }
  }
`;
